<template>
    <div style="width: 100%; text-align: center; padding-left: 12px; padding-right: 12px; color: white;">
        <v-row>
            <label>Finance Connected &copy; {{ currentYear }} | {{ environmentLabel }}<span v-if="currentDatabase && $route.name != 'Login'" style="color: red; font-size: 1.2em; font-weight: bold;"> | DB: {{ currentDatabase }}</span></label>
            <v-spacer></v-spacer>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <label v-bind="attrs" v-on="on" v-show="$route.name != 'Login'">Tiempo de sesión restante: {{
                        remainingTime }}</label>
                </template>
                <span>Su sesión expira a las {{ formattedExpirationDate }}</span>
            </v-tooltip>
        </v-row>
        <SessionExpired v-if="loggedIn.authStatus" :showDialog="dialogSesionExpired"
            @closeDialog="dialogSesionExpired = false" />
    </div>
</template>

<script>
import SessionExpired from '@/components/SessionExpired.vue'
import moment from "moment";
import { mapState } from "vuex";
import jwt_decode from "jwt-decode";
export default {
    props: {
        environmentLabel: String,
        currentDatabase: String
    },

    data() {
        return {
            currentYear: moment().format('YYYY'),
            padless: false,
            variant: 'default',
            remainingTime: '',
            showFooter: true,
            expirationDate: moment(),
            dialogSesionExpired: false,
            widthtScreen: 500
        };
    },
    computed: {
        ...mapState({
            loggedIn: (state) => state.auth,
            user: (state) => state.auth.user?.user,
        }),
        localAttrs() {
            const attrs = {}

            if (this.variant === 'default') {
                attrs.absolute = false
                attrs.fixed = false
            } else {
                attrs[this.variant] = true
            }
            return attrs
        },
        formattedExpirationDate() {
            return this.expirationDate.format('hh:mm:ss A');
        }
    },
    components: {
        SessionExpired
    },
    mounted() {
        const token = localStorage.getItem("token");
        const { exp } = jwt_decode(token);
        this.expirationDate = moment.unix(exp);
        this.updateRemainingTime();
    },
    methods: {

        updateRemainingTime() {
            this.widthtScreen = window.innerWidth;
            if (this.dialogSesionExpired == true) {
                return
            }

            const duration = moment.duration(this.expirationDate.diff(moment()));
            const hours = duration.hours();
            const minutes = duration.minutes();
            const seconds = duration.seconds();
            if (seconds < 0) {
                this.remainingTime = '0:00:00'
                this.dialogSesionExpired = true;
                return
            }
            this.remainingTime = `${hours}h ${minutes}m ${seconds}s`
            setTimeout(() => {
                this.updateRemainingTime();
            }, 1000);
        },
    }
};
</script>
